import { call, put, takeLatest } from 'redux-saga/effects';
import apiCall from '../helpers/ApiCall';
import apiRoot from '../consts/apiRoot';
import {
  SET_PICKUP_DATE,
  SET_PICKUP_DATE_SUCCESS,
  SET_PICKUP_DATE_FAIL
} from '../redux/OffersDetails';

function* SetPickUpDateFlow({ payload: { hashId, pickUpDate, }, }) {
  try {
    const endpoint = `${apiRoot}/offers/${hashId}`;
    const params = {
      offer: {
        pick_up_date: pickUpDate,
      },
    };
    const response = yield call(apiCall, { method: 'PUT', endpoint, params, });
    yield put(SET_PICKUP_DATE_SUCCESS({ pick_up_date: response.pick_up_date, }));
  } catch (error) {
    yield put(SET_PICKUP_DATE_FAIL(error));
  }
}

export default function* SetPickUpDate() {
  yield takeLatest(SET_PICKUP_DATE, SetPickUpDateFlow);
}
